import api, { API_BASE_URL } from '../config/api';

const authService = {
  async login(username, password) {
    try {
      const response = await api.post('/api/admin/auth/signin', {
        username,
        password,
      });

      if (response.data.success) {
        const token =
          (typeof response.data.token === 'string' && response.data.token.trim()) ||
          (typeof response.data.Token === 'string' && response.data.Token.trim()) ||
          null;
        if (!token) {
          return {
            success: false,
            error: `The API (${API_BASE_URL}) accepted login but did not return a JWT. Deploy the latest RAK.Server (admin sign-in must include "token"), then try again.`,
          };
        }
        return {
          success: true,
          user: response.data.user,
          token,
        };
      }
      
      return {
        success: false,
        error: response.data.error || 'Invalid credentials',
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || error.message || 'Login failed',
      };
    }
  },

  async logout() {
    try {
      await api.post('/api/admin/auth/logout');
    } catch (error) {
      console.error('Logout error:', error);
    }
  },

  async getCurrentUser() {
    try {
      const response = await api.get('/api/admin/auth/current');
      return response.data;
    } catch (error) {
      console.error('Get current user error:', error);
      return null;
    }
  },
};

export default authService;
